import React from 'react'
import PropTypes from 'prop-types'

import classes from './FilterBar.scss'
import Button from '../UI/Button/Button'
import FilterListIcon from '@material-ui/icons/FilterList'
import { withTranslate } from 'react-redux-multilingual'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const FilterBar = ({ buttonClicked, translate }) => {
  const theme = useTheme()
  const Mobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <div className={classes.FilterBar}>
      {Mobile ? (
        <Button
          size={'small'}
          clicked={buttonClicked}
          btnClass={classes.FilterButtonMobile}
          variant={'outlined'}>
          <FilterListIcon />
        </Button>
      ) : (
        <Button
          size={'small'}
          clicked={buttonClicked}
          btnClass={classes.FilterButton}
          variant={'outlined'}
          startIcon={<FilterListIcon />}>
          {translate('filter')}
        </Button>
      )}
    </div>
  )
}

FilterBar.propTypes = {
  buttonClicked: PropTypes.func.isRequired
}

export default withTranslate(FilterBar)
